import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import GuideHero from './components/GuideHero';
import QuickGuideCards from './components/QuickGuideCards';
import InteractiveQuiz from './components/InteractiveQuiz';
import GuideCategories from './components/GuideCategories';
import ExpertInsights from './components/ExpertInsights';
import TrendingTopics from './components/TrendingTopics';
import NewsletterSignup from './components/NewsletterSignup';

const BuyingGuide = () => {
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  const handleStartQuiz = () => {
    setIsQuizOpen(true);
  };

  const handleCloseQuiz = () => {
    setIsQuizOpen(false);
  };

  const handleQuizComplete = (answers) => {
    console.log('Quiz completed with answers:', answers);
    setIsQuizOpen(false);
    // Here you would typically process the answers and show recommendations
    alert(`Great! Based on your answers, we'll show you personalized recommendations.\n\nYour preferences:\n- Home size: ${answers?.['home-size']}\n- Floor type: ${answers?.['floor-type']}\n- Lifestyle: ${answers?.['lifestyle']}\n- Budget: ${answers?.['budget']}`);
  };

  const handleViewGuides = () => {
    // Scroll to guides section
    const guidesSection = document.getElementById('guide-categories');
    if (guidesSection) {
      guidesSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSelectGuide = (guideId) => {
    console.log('Selected guide:', guideId);
    // Here you would navigate to the specific guide page
    alert(`Opening guide: ${guideId}`);
  };

  const handleSelectCategory = (categoryId, guideName = null) => {
    console.log('Selected category:', categoryId, 'Guide:', guideName);
    // Here you would navigate to the category page or specific guide
    if (guideName) {
      alert(`Opening guide: ${guideName} in category: ${categoryId}`);
    } else {
      alert(`Opening category: ${categoryId}`);
    }
  };

  const handleReadMore = (insightId) => {
    console.log('Reading insight:', insightId);
    // Here you would navigate to the full insight article
    alert(`Opening insight article: ${insightId}`);
  };

  const handleSelectTopic = (topicId) => {
    console.log('Selected trending topic:', topicId);
    // Here you would navigate to the trending topic page
    alert(`Opening trending topic: ${topicId}`);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <GuideHero 
          onStartQuiz={handleStartQuiz}
          onViewGuides={handleViewGuides}
        />
        
        <QuickGuideCards 
          onSelectGuide={handleSelectGuide}
        />
        
        <div id="guide-categories">
          <GuideCategories 
            onSelectCategory={handleSelectCategory}
          />
        </div>
        
        <ExpertInsights 
          onReadMore={handleReadMore}
        />
        
        <TrendingTopics 
          onSelectTopic={handleSelectTopic}
        />
        
        <NewsletterSignup />
      </main>
      <InteractiveQuiz
        isOpen={isQuizOpen}
        onClose={handleCloseQuiz}
        onComplete={handleQuizComplete}
      />
      {/* Footer */}
      <footer className="bg-text-primary text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="text-primary-foreground"
                  >
                    <path
                      d="M12 2L2 7V17L12 22L22 17V7L12 2Z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 22V12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <path
                      d="M2 7L12 12L22 7"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <circle
                      cx="12"
                      cy="9"
                      r="2"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
                <div>
                  <span className="text-xl font-bold">Vacuum Guide</span>
                  <p className="text-sm text-white/70">Expert vacuum reviews and buying guides</p>
                </div>
              </div>
              <p className="text-white/80 mb-4">
                Your trusted source for honest vacuum cleaner reviews, comprehensive buying guides, and expert recommendations. Making informed appliance decisions easier since 2020.
              </p>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm text-white/80">
                <li><a href="/product-review" className="hover:text-white transition-colors">Product Reviews</a></li>
                <li><a href="/comparison-tool" className="hover:text-white transition-colors">Compare Vacuums</a></li>
                <li><a href="/deal-tracker" className="hover:text-white transition-colors">Best Deals</a></li>
                <li><a href="/buying-guide" className="hover:text-white transition-colors">Buying Guides</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold mb-4">Support</h3>
              <ul className="space-y-2 text-sm text-white/80">
                <li><a href="#" className="hover:text-white transition-colors">Contact Us</a></li>
                <li><a href="#" className="hover:text-white transition-colors">About</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm text-white/60">
            <p>&copy; {new Date()?.getFullYear()} Vacuum Guide. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BuyingGuide;